export default "__VITE_ASSET__BBxVwZWO__"